/* eslint-disable import/prefer-default-export */
import {
    DataGridSupportedFeatures,
    SkyDataGridColumnDefinition,
    FilterOperatorType,
    SkyNetDataGridFilterType,
} from '../SkyBaseDataGrid.types'

export const featuresToHiddenColumns = (
    featuresLists: DataGridSupportedFeatures[],
): SkyDataGridColumnDefinition<any>[] => {
    if (featuresLists.includes(DataGridSupportedFeatures.ShowArchived, 0)) {
        return [{
            name: 'archived',
            minWidth: 50,
            sorting: false,
            filterable: false,
            filterType: SkyNetDataGridFilterType.Toggle,
            filterParams: {
                defaultValue: false,
                operator: FilterOperatorType.DataFilter,
            },
            headerName: 'Show Archived Only',
            hiddenFromColumns: true,
        }]
    }
    return []
}
